import { Input, Row } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ChatInput = ({ sendComment, messages }) => {
  const [comment, setComment] = useState(''),
    { t } = useTranslation();

  function handleComment(text) {
    sendComment(text);
    setComment('');
  }

  return (
    <Row wid="calc(100% - 32px)" bg="rgba(0, 0, 0, 0.5)" pad="16px">
      <Input
        emoji
        emojiMarg="0 8px 0 0"
        value={comment}
        onChange={({ target }) => setComment(target.value)}
        style={{ color: '#fff', borderColor: '#fff' }}
        onSend={(text) => handleComment(text)}
        placeholder={t('goLive.comment')}
        innerPad="0 12px"
        bg="rgba(0, 0, 0, 0.8)"
      />
    </Row>
  );
};

export default ChatInput;
